import { render, staticRenderFns } from "./PostPage.vue?vue&type=template&id=da6bffe0&scoped=true&"
import script from "./PostPage.vue?vue&type=script&lang=js&"
export * from "./PostPage.vue?vue&type=script&lang=js&"
import style0 from "./PostPage.vue?vue&type=style&index=0&id=da6bffe0&scoped=true&lang=css&"
import style1 from "./PostPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da6bffe0",
  null
  
)

export default component.exports